import $ from 'jquery';
import { validationOptions } from '../../../constants/options';
import { validateEmail, requiredValidation, phoneNumberValidation, } from '../../../components/validations';
import { toggleButtonLoader } from '../../../utils/button-loader';
import GaTracking from '../../../core/components/ga-tracking';
import { getEnglishErrorMessageByMessageText } from '../../../utils/error';
export default class Registration {
    static $form;
    static errors;
    static init() {
        if ($('.js__registration-form').length) {
            this.$form = $('.js__registration-form');
            this.errors = $('.js__form-error-translations').data('errors');
            toggleButtonLoader($('.js__registration-submit'), false);
            this.bindEvents();
            setTimeout(() => {
                if ($('.js__registration-email-input').val()) {
                    this.$form.valid();
                }
                toggleButtonLoader($('.js__registration-submit'), false);
            }, 200);
        }
    }
    static bindEvents() {
        const errorDatalayer = this.$form.data('datalayer-on-error');
        this.$form.validate({
            ...validationOptions,
            onkeyup: element => {
                if ($(element).hasClass('js__registration-email-input')) {
                    return false;
                }
                if ($(element).hasClass('js__registration-phone-number-input')) {
                    return false;
                }
                $(element).valid();
            },
            onfocusout: element => {
                $(element).valid();
            },
            invalidHandler: (evt, error) => {
                $.each(error.errorList, (index, item) => {
                    // @ts-ignore
                    const message = item.method ? $(item.element).data(`${item.method}Error`) : item.message;
                    GaTracking.pushDataLayer({
                        event: 'systemError',
                        errorType: 'form registration',
                        errorMessage: getEnglishErrorMessageByMessageText(message || item.message),
                    });
                    if (errorDatalayer) {
                        GaTracking.pushDataLayer({
                            ...errorDatalayer,
                            errorMessage: getEnglishErrorMessageByMessageText(message || item.message),
                        });
                    }
                });
            },
        });
        this.bindValidations();
        $('.js__registration-submit').on('click', e => {
            if (this.$form.valid() && !this.$form.find('.pending').length) {
                setTimeout(() => {
                    toggleButtonLoader($(e.currentTarget), true);
                    this.handleSubmit();
                });
            }
            else if (errorDatalayer) {
                const validator = this.$form.validate();
                validator.errorList.forEach(error => {
                    GaTracking.pushDataLayer({
                        ...errorDatalayer,
                        eventLabel: `Error - ${getEnglishErrorMessageByMessageText(error.message)}`,
                    });
                });
            }
        });
    }
    static handleSubmit() {
        if (window.grecaptcha) {
            const $captchaInput = $('.js__registration-captcha');
            grecaptcha.execute($captchaInput.data('site-key'), { action: 'shop_login' }).then(token => {
                $captchaInput.val(token);
                this.$form.submit();
            });
        }
        else {
            this.$form.submit();
        }
    }
    static bindValidations() {
        validateEmail(this.$form.find('.js__registration-email-input'), this.$form, this.errors);
        requiredValidation($('.js__registration-rules-and-privacy-policy-agreement-checkbox'), this.errors);
        requiredValidation($('.js__registration-adult-person-agreement-input'), this.errors);
        phoneNumberValidation($('.js__registration-phone-number-input'), this.$form, this.errors);
    }
}
